import { ChangeDetectionStrategy, Component } from '@angular/core';

import { CheckboxComponent } from '@shared/components/checkbox/checkbox.component';
import { SelectComponent } from '@shared/components/select/select.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SelectComponent, CheckboxComponent],
  selector: 'aux-risk-alert-dialog',
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
  templateUrl: './risk-alert-dialog.component.html',
})
export class RiskAlertDialogComponent {
  averageOptions = ['1 Week', '2 Weeks', '3 Weeks'];
  lessOptions = ['75%', '80%', '85%'];
  moreOptions = ['75%', '80%', '85%'];
  siteVisitOptions = ['1 Month', '2 Months', '3 Months'];
}
